import { useState } from 'react';
import { AppHeader } from '../components/AppHeader';
import { Icon } from '../components/Icon';

interface NewMovieScreenProps {
  onBack: () => void;
  onCreate: (title: string) => Promise<void>;
}

export function NewMovieScreen({ onBack, onCreate }: NewMovieScreenProps) {
  const [title, setTitle] = useState('');
  const [working, setWorking] = useState(false);
  const [error, setError] = useState('');

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    if (working) return;
    setWorking(true);
    setError('');
    try {
      await onCreate(title);
    } catch {
      setError('Your movie could not be started. Check this device’s storage and try again.');
      setWorking(false);
    }
  }

  return (
    <div className="screen-shell">
      <AppHeader title="New Movie" onBack={onBack} backLabel="Back to home" />
      <main className="narrow-screen">
        <div className="big-friendly-icon"><Icon name="sparkles" /></div>
        <h2>What should we call it?</h2>
        <p className="muted">You can skip this if you want.</p>
        <form onSubmit={(event) => { void submit(event); }} className="new-movie-form">
          <label htmlFor="movie-title">Movie name <span>(optional)</span></label>
          <input
            id="movie-title"
            maxLength={60}
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            placeholder="My Amazing Movie"
            autoComplete="off"
          />
          {error && <p className="form-error" role="alert">{error}</p>}
          <button className="button primary big-button" type="submit" disabled={working}>
            <Icon name="camera" /> {working ? 'Starting…' : 'Start Taking Pictures'}
          </button>
        </form>
        <p className="permission-promise"><span aria-hidden="true">📷</span> Next, we’ll ask to use the camera. Pictures stay here.</p>
      </main>
    </div>
  );
}

